import styled from 'styled-components';
import { CaptionText } from '@prisjakt/ui/text/variants';
import { layout } from '@prisjakt/ui-base';

export const StyledDeliveryTime = styled.div`
  display: flex;
  align-items: center;
  gap: ${layout.measurements.spacing025};
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledCaptionText = styled(CaptionText)`
  white-space: nowrap;
`;
